<template>
  <v-container fluid>
    <v-tabs v-model="tabIndex">
      <v-tab v-for="(item, i) in tabs" :key="i">
        {{ item }}
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="tabIndex"
      :class="$vuetify.breakpoint.smAndDown ? 'px-0 mt-8' : 'pa-8'"
    >
      <v-tab-item class="d-flex">
        <v-row style="width: 100%">
          <v-col cols="12" class="d-flex justify-end flex-wrap">
            <v-btn
              outlined
              elevation="0"
              class="text-capitalize rounded-pill font-weight-bold mr-3 mb-2"
              color="primary"
              @click="addSection"
            >
              <v-icon>mdi-table-row-plus-after</v-icon>
              Agregar sección
            </v-btn>
            <v-btn
              elevation="0"
              class="text-capitalize rounded-pill font-weight-bold mb-2"
              :color="color.secondary"
              @click="handleBenefitDialog({}, false)"
            >
              <v-icon>mdi-plus</v-icon>
              Agregar Beneficio
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-tabs v-model="sectionTab" show-arrows>
              <v-tab v-for="section in sectionTabs" :key="section._id || 'unsectioned'">
                {{ section.name }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="sectionTab">
              <v-tab-item
                v-for="section in sectionTabs"
                :key="section._id || 'unsectioned-content'"
              >
                <v-row v-if="section._id" align="center" class="mt-3 mb-1" no-gutters>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="section.name"
                      label="Nombre de la sección"
                      dense
                      filled
                      rounded
                      hide-details
                      @focus="section._editing = true"
                    />
                  </v-col>
                  <v-col cols="auto" class="ml-2">
                    <v-btn
                      v-if="section._editing"
                      icon
                      small
                      color="green"
                      :loading="savingSectionId === section._id"
                      @click="saveSectionName(section)"
                    >
                      <v-icon small>mdi-content-save-outline</v-icon>
                    </v-btn>
                    <v-btn icon small color="red" @click="requestRemoveSection(section)">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row v-if="benefitsForSection(section._id).length === 0" class="mt-4">
                  <v-col cols="12" class="text-center grey--text">
                    No hay beneficios en esta sección.
                  </v-col>
                </v-row>
                <v-row v-else class="mt-2">
                  <v-col
                    :cols="
                      $vuetify.breakpoint.smAndDown
                        ? 12
                        : $vuetify.breakpoint.lgAndDown
                        ? 12
                        : 4
                    "
                    v-for="(item, i) in benefitsForSection(section._id)"
                    :key="item._id || i"
                  >
                    <benefitsCard
                      :name="item.name"
                      :description="item.description"
                      :icon="item.icon"
                      @edit="handleBenefitDialog(item, true)"
                      @delete="handleDelete(item._id)"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
    <!-- Dialog: Eliminar beneficio -->
    <PersonalizedDialog
      :dialog="!!handleBenefitIdToDelete"
      @save="deleteRegist(handleBenefitIdToDelete)"
      @discard="handleDelete(null)"
    >
      <template #alertName> Eliminar Beneficio </template>
      <template #alertContent>
        <div class="text-center">
          <p>Seguro que quieres eliminar los datos de este beneficio?</p>
        </div>
      </template>
    </PersonalizedDialog>

    <!-- Dialog: Eliminar sección -->
    <v-dialog v-model="sectionDeleteDialog" max-width="430">
      <v-card>
        <v-card-title>Eliminar sección</v-card-title>
        <v-card-text>
          Los beneficios de esta sección pasarán a “Sin sección”. ¿Deseas continuar?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="sectionDeleteDialog = false">Cancelar</v-btn>
          <v-btn color="red" text :loading="deletingSection" @click="removeSection">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- :dialog="dialogComputed" -->
    <!-- Dialog: Editar información del beneficio  -->
    <PersonalizedDialog
      :dialog="!!handleBenefitItemToUpdate"
      :hideImage="true"
      :disableContinueButton="!(formValid || imageUploaded)"
      @save="editSwitch ? editBenefit() : createNewBenefit()"
      @discard="closeBenefitsDialog()"
    >
      <template #alertName>
        {{ editSwitch ? 'Editar' : 'Crear nuevo' }} beneficio
      </template>
      <template #alertContent>
        <div class="d-flex justify-center flex-column">
          <p class="text-center ma-0 mb-4">
            Carga aquí la información de tu nuevo beneficio. Recomendamos que
            las dimensiones de la imagen sean como mínimo de 250 x 250 pixeles
          </p>
          <v-form v-model="formValid">
            <div
              v-for="field in handleBenefitItemToUpdate"
              :key="field.id"
              class="text-center"
            >
              <ImageUploader
                v-if="field.id == 'icon'"
                :imgUrl="
                  field.value != null
                    ? field.value
                    : '@/assets/images/weChamber/wechamber-blue-logo-placeholder.png'
                "
                @save="handleIcon"
              />
              <v-select
                v-else-if="field.id == 'section'"
                v-model="field.value"
                class="mt-4"
                rounded
                filled
                clearable
                :label="field.label"
                item-text="name"
                item-value="_id"
                :items="benefitSectionOptions"
                :background-color="textAreabgColor"
              />
              <v-text-field
                v-else-if="!['expiredDate', 'description', 'section'].includes(field.id)"
                v-model="field.value"
                class="mt-4"
                rounded
                filled
                :label="field.label"
                :rules="[...field.rule]"
                :background-color="textAreabgColor"
              >
              </v-text-field>
              <v-textarea
                v-else-if="field.id == 'description'"
                rounded
                auto-grow
                :background-color="textAreabgColor"
                v-model="field.value"
                filled
                :label="field.label"
                :rows="1"
                :rules="[...field.rule]"
                :counter="150"
              >
              </v-textarea>
              <v-menu
                v-else
                :style="{ backgroundColor: textAreabgColor }"
                filled
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="field.value"
                    :label="field.label"
                    persistent-hint
                    readonly
                    filled
                    rounded
                    min
                    v-on="on"
                    :background-color="textAreabgColor"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                  />
                </template>
                <v-date-picker
                  v-model="field.value"
                  no-title
                  scrollable
                  :min="minDate"
                  locale="es"
                >
                </v-date-picker>
              </v-menu>
            </div>

            <!-- <div class="text-center mt-4">
              <p class="ma-0">
                ¿Desea enviar una notificación por email a los miembros de la
                organización?
              </p>
              <v-checkbox
                dense
                label="Enviar notificación"
                v-model="sendEmailNotification"
                @change="() => (selectedSubgroups = [])"
              ></v-checkbox>
            </div>
            <div v-if="sendEmailNotification">
              <v-combobox
                v-model="selectedSubgroups"
                label="¿A que grupo de miembros deseas enviar notificaciones?"
                :items="subgroups"
                :background-color="textAreabgColor"
                persistent-hint
                hide-details
                rounded
                deletable-chips
                chips
                small-chips
                filled
                :multiple="true"
                hide-selected
              >
              </v-combobox>
            </div> -->
            <AudienceDialog
              ref="audience_configs"
              :benefit="handleBenefitIdToUpdate"
              :editMode="editSwitch"
              :hideBranches="!hasChapters"
            />
          </v-form>
        </div>
      </template>
    </PersonalizedDialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import { colors } from '@/constants/colors.js';
import benefitsCard from '@/components/dashboard/Benefits/benefitsCard';
import PersonalizedDialog from '@/components/shared/PersonalizedDialog';
import { mapActions, mapMutations, mapState } from 'vuex/dist/vuex.common.js';
import ImageUploader from '../../../components/shared/ImageUploader.vue';
import AudienceDialog from '../../../components/dashboard/audienceRules/AudienceDialog.vue';
import { hasOrganizationChapters } from '@/common/ampiOrganizationUserAccess';

export default {
  components: {
    benefitsCard,
    PersonalizedDialog,
    ImageUploader,
    AudienceDialog,
  },
  data() {
    return {
      imageUploaded: false,
      confirmDialog2: true,
      handleBenefitIdToDelete: null,
      handleBenefitIdToUpdate: null,
      handleBenefitItemToUpdate: null,
      company: '',
      textAreabgColor: '#f2f2f2',
      emails: [],
      selectedSubgroups: ['Enviar a Todos'],
      subgroups: ['Enviar a Todos'],
      sendEmailNotification: false,
      selectedOption: 'no',
      confirmOption: false,
      tabIndex: 0,
      sectionTab: 0,
      benefitsList: [],
      sections: [],
      savingSectionId: null,
      deletingSection: false,
      sectionDeleteDialog: false,
      sectionToDelete: null,
      tabs: ['Beneficios del Organizador'],
      color: colors,
      dialog: false,
      editSwitch: false,
      deleteSwitch: false,
      temporalId: '',
      formValid: false,
      benefitBaseForm: [
        {
          value: null,
          id: 'icon',
          rule: [],
        },
        {
          value: '',
          label: 'Nombre comercial del beneficio',
          id: 'name',
          rule: [(v) => !!v || 'Asignar nombre al beneficio'],
        },
        {
          value: '',
          label: 'URL del beneficio',
          id: 'url',
          rule: [],
          /*rule: (v) =>
            !!!v || /^(https?):\/\/[^\s/$.?#].[^\s]*$/.test(v) || "error",*/
        },
        {
          value: null,
          label: 'Sección',
          id: 'section',
          rule: [],
        },
        {
          value: '',
          label: 'Fecha de expiración',
          id: 'expiredDate',
          rule: [],
        },
        {
          value: '',
          label: 'Descripción e instrucción para usar beneficio',
          id: 'description',
          rule: [
            (v) =>
              v.length <= 150 || 'Ha excedido la longitud máxima de caracteres',
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState('user', ['user']),
    hasChapters() {
      return hasOrganizationChapters(this.user);
    },
    dialogComputed() {
      if (this.confirmDialog2 == true) {
        this.dialog = true;
      }
      return this.dialog;
    },
    editComputed() {
      return this.editSwitch;
    },
    minDate() {
      return new Date().toISOString().slice(0, 10);
    },
    sectionTabs() {
      return [{ _id: null, name: 'Sin sección' }, ...this.sections];
    },
    benefitSectionOptions() {
      return this.sectionTabs;
    },
  },
  async created() {
    this.loading();
    try {
      await this.fetchSubgroups();
      await Promise.all([this.getBenefitsList(), this.getSections()]);
    } catch (error) {
      console.log(error);
    } finally {
      this.loaded();
    }
  },
  methods: {
    ...mapActions('user', ['realoadUserData']),

    ...mapActions('benefits', [
      'setBenefits',
      'getBenefits',
      'setBenefitsById',
      'deleteBenefit',
    ]),
    ...mapActions('benefitSections', [
      'getBenefitSectionsByOrg',
      'addBenefitSection',
      'updateBenefitSection',
      'deleteBenefitSection',
    ]),
    ...mapMutations('notification', ['show']),
    ...mapMutations('loader', ['loading', 'loaded']),

    onOptionChange() {
      this.selectedOption = 'yes';
      if (this.selectedOption === 'yes') {
        this.confirmDialog2 = true;
      } else {
        this.selectedSubgroup = '';
      }
    },

    async fetchSubgroups() {
      try {
        const response = await axios.get('/subgroups/');
        this.subgroups = [
          'Enviar a Todos',
          ...response.data.map((subgroup) => subgroup.name),
        ];
      } catch (error) {
        console.error('Error fetching subgroups:', error);
      }
    },
    async fetchEmails() {
      try {
        const response = await axios.get('/subgroups/');

        if (this.selectedSubgroups.includes('Enviar a Todos')) {
          this.emails = response.data.flatMap((subgroup) =>
            subgroup.members.map((member) => member.email)
          );
        } else {
          this.emails = response.data
            .filter((subgroup) =>
              this.selectedSubgroups.includes(subgroup.name)
            )
            .flatMap((subgroup) =>
              subgroup.members.map((member) => member.email)
            );
        }

        return this.emails;
      } catch (error) {
        console.error('Error fetching emails:', error);
        this.show({
          color: 'error',
          text: 'Error al obtener los correos electrónicos.',
        });
        return [];
      }
    },

    async postBenefitNotification() {
      try {
        const emails = await this.fetchEmails();
        await this.axios.post('users/send-benefit-notification', {
          benefitTitle: data.name,
          emails: emails,
        });
      } catch (error) {
        this.show({
          color: 'error',
          text: 'Ya has creado 3 beneficios con notificaciones hoy. Inténtalo de nuevo mañana.',
        });
      }
    },

    async createNewBenefit() {
      try {
        let data = this.reduceFormData(this.handleBenefitItemToUpdate);
        if (this.sendEmailNotification) {
          await this.postBenefitNotification(data.name);
        }
        // handle post benefit logo
        data.icon = await this.postBenefitLogo(data.icon);

        const response = await this.setBenefits(data);

        if (response.status) {
          this.show({
            color: 'success',
            text: response.message,
          });
          await this.$refs.audience_configs.createRules({
            benefit: response.data._id,
          });
        } else {
          this.show({
            color: 'error',
            text: response.message,
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        await this.getBenefitsList();
      }
    },

    async postBenefitLogo(value = null) {
      let location = '';
      if (!value) {
        return location;
      }
      try {
        let formData = new FormData();
        formData.append('file', value);
        const response = await this.axios.post('/benefits/set-logo', formData);
        if (response.status == 200) {
          location = response.data.location;
        }
      } catch (error) {
        console.log(error);
      } finally {
        return location;
      }
    },

    handleBenefitDialog(item = null, edit = false) {
      this.editSwitch = edit;

      let benefitSelected = item;
      this.handleBenefitIdToUpdate = item._id;
      const currentDate = new Date().toISOString().slice(0, 10);

      this.handleBenefitItemToUpdate = [...this.benefitBaseForm].map(
        (element) => {
          const expiredDate = this.editSwitch
            ? String(benefitSelected[element.id]).substring(0, 10)
            : currentDate;
          return {
            ...element,
            value:
              element.id === 'expiredDate'
                ? expiredDate
                : element.id === 'section'
                ? this.getBenefitSectionId(benefitSelected)
                : benefitSelected[element.id] || '',
          };
        }
      );
    },

    handleDelete(itemId = null) {
      this.handleBenefitIdToDelete = itemId;
    },

    async editBenefit() {
      try {
        let handleBenefitItemToUpdate = this.handleBenefitItemToUpdate;

        if (typeof handleBenefitItemToUpdate[0].value == 'object') {
          handleBenefitItemToUpdate[0].value = await this.postBenefitLogo(
            handleBenefitItemToUpdate[0].value
          );
        }

        let data = this.reduceFormData(handleBenefitItemToUpdate);

        if (this.sendEmailNotification) {
          await this.postBenefitNotification(data.name);
        }

        let response = await this.setBenefitsById({
          form: data,
          id: this.handleBenefitIdToUpdate,
        });
        if (response.status) {
          this.show({
            color: 'success',
            text: response.message,
          });
          await this.$refs.audience_configs.updateRules({
            benefit: response.data._id,
          });
        } else {
          this.show({
            color: 'error',
            text: response.message,
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        await this.getBenefitsList();
        await this.cleanForm();
      }
    },

    handleIcon(file, resetState) {
      let index = [...this.handleBenefitItemToUpdate].findIndex(
        (element) => element.id === 'icon'
      );
      this.handleBenefitItemToUpdate[index].value = file;
      this.imageUploaded = !!file;
      resetState();
    },

    async getBenefitsList() {
      try {
        let response = await this.getBenefits();
        if (response) {
          this.benefitsList = response.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getSections() {
      const response = await this.getBenefitSectionsByOrg();
      this.sections = response.status
        ? (response.data.sections || []).map((section) => ({ ...section, _editing: false }))
        : [];
      if (this.sectionTab >= this.sectionTabs.length) this.sectionTab = 0;
    },

    getBenefitSectionId(benefit) {
      const section = benefit && benefit.section;
      if (!section) return null;
      if (typeof section === 'object') return section._id || section.id || null;
      return section;
    },

    benefitsForSection(sectionId) {
      return this.benefitsList.filter((benefit) => (
        String(this.getBenefitSectionId(benefit) || '') === String(sectionId || '')
      ));
    },

    async addSection() {
      const nextOrder = this.sections.reduce(
        (max, section) => Math.max(max, Number(section.order) || 0),
        0,
      ) + 1;
      const response = await this.addBenefitSection({
        name: 'Nueva sección',
        order: nextOrder,
      });
      if (!response.status) {
        this.show({ color: 'error', text: 'No se pudo crear la sección' });
        return;
      }
      this.sections.push({ ...response.data.section, _editing: true });
      this.sectionTab = this.sections.length;
    },

    async saveSectionName(section) {
      this.savingSectionId = section._id;
      const response = await this.updateBenefitSection({
        id: section._id,
        payload: { name: section.name, order: section.order },
      });
      this.savingSectionId = null;
      if (response.status) {
        Object.assign(section, response.data.section, { _editing: false });
      } else {
        this.show({ color: 'error', text: 'No se pudo actualizar la sección' });
      }
    },

    requestRemoveSection(section) {
      this.sectionToDelete = section;
      this.sectionDeleteDialog = true;
    },

    async removeSection() {
      if (!this.sectionToDelete) return;
      const sectionId = this.sectionToDelete._id;
      this.deletingSection = true;
      const response = await this.deleteBenefitSection(sectionId);
      this.deletingSection = false;
      this.sectionDeleteDialog = false;
      if (!response.status) {
        this.show({ color: 'error', text: 'No se pudo eliminar la sección' });
        return;
      }
      this.sections = this.sections.filter((section) => section._id !== sectionId);
      this.sectionToDelete = null;
      this.sectionTab = 0;
      await this.getBenefitsList();
      this.show({ color: 'primary', text: 'Sección eliminada' });
    },

    async deleteRegist(benefitId = null) {
      try {
        let response = await this.deleteBenefit(benefitId);
        if (response.status) {
          this.show({
            color: 'success',
            text: response.message,
          });
          await this.getBenefitsList();
        } else {
          this.show({
            color: 'error',
            text: response.message,
          });
        }
      } catch (error) {
        console.log(error);
      }
      this.deleteSwitch = false;
    },

    reduceFormData(dataToReduce = null) {
      if (!!!dataToReduce) return;
      return [...dataToReduce].reduce((obj, item) => {
        obj[item.id] = item.value;
        return obj;
      }, {});
    },

    cleanForm() {
      this.imageUploaded = false;
      this.editSwitch = false;
      this.temporalId = '';
      this.handleBenefitItemToUpdate = null;
      this.selectedSubgroups = [];
      this.sendEmailNotification = false;
    },

    closeBenefitsDialog() {
      this.handleBenefitItemToUpdate = null;
      this.$refs.audience_configs.setRules();
    },
  },
};
</script>
